import "devextreme/dist/css/dx.common.css";
import "devextreme/dist/css/dx.light.css";
import "@babel/polyfill";
import "mutationobserver-shim";
import Vue from "vue";
import "./plugins/bootstrap-vue";
import App from "./App.vue";
import router from "./router";
import 'vue-awesome/icons'
import Vuex from "vuex";
Vue.use(Vuex);
import vueDebounce from 'vue-debounce'
Vue.use(vueDebounce)

import VueExcelXlsx from "vue-excel-xlsx";
Vue.use(VueExcelXlsx);

import Icon from 'vue-awesome/components/Icon'
Vue.component('v-icon', Icon)

import { API } from "@/api.js";

Icon.register({
    privacy: {
      width: 491,
      height: 511.51,
      d: "M231.91 0C318.7 55.01 397.1 81.04 464.39 74.88c4.4 89.16-5.19 164.63-27.12 227.21-.88.29-1.76.62-2.62.99-.58-1.14-1.25-2.22-1.99-3.23a32.23 32.23 0 0 0-6.24-7l-1.01-.8a32.776 32.776 0 0 0-10.5-5.46c-1.93-.6-3.86-1.02-5.81-1.27 16.27-51.04 23.25-111.74 19.74-182.69-56.96 5.21-123.33-16.83-196.8-63.4-63.57 49.39-129.18 63.85-196.05 60.34-5.58 212.57 69.64 326.28 196.81 372.7 23.78-8.95 45.67-20.18 65.55-33.73l.33.28.19.19c2.74 2.34 5.77 4.2 9.06 5.54-1.36 4.19-1.88 8.46-1.51 12.83.37 4.4 1.64 8.63 3.73 12.67l.68 1.22c-23.64 16.19-49.7 29.57-78.01 40.24C82.6 456.68-6.25 322.35.34 71.27 79.33 75.41 156.82 58.33 231.91 0zm221.36 327.1c-1.91-1.6-4.04-2.29-6.43-2.08-2.38.2-4.39 1.24-5.97 3.14l-8.64 10.23c-2.68-1.42-5.48-2.62-8.39-3.66-2.92-1.04-5.87-1.9-8.85-2.61l-1.24-14.49c-.21-2.44-1.21-4.42-3.06-5.98-1.84-1.55-3.97-2.21-6.41-2l-18.19 1.56c-2.32.2-4.27 1.2-5.89 3.05-1.58 1.85-2.27 3.98-2.06 6.42l1.14 13.27c-2.98.97-5.86 2.12-8.6 3.47a67.95 67.95 0 0 0-7.81 4.45l-11.34-9.42c-1.79-1.59-3.86-2.31-6.28-2.11-2.39.21-4.37 1.28-5.98 3.15l-11.63 13.86c-1.61 1.9-2.3 4.03-2.09 6.41.2 2.39 1.25 4.4 3.15 5.98l10.23 8.65c-1.42 2.67-2.62 5.47-3.67 8.38-1.04 2.91-1.89 5.87-2.6 8.84l-14.49 1.25c-2.44.2-4.43 1.21-5.98 3.06-1.55 1.84-2.21 3.97-2.01 6.41l1.56 18.19c.2 2.32 1.21 4.28 3.05 5.89 1.85 1.58 3.98 2.27 6.43 2.06l13.26-1.13c.97 2.97 2.12 5.85 3.47 8.59 1.35 2.76 2.84 5.43 4.46 7.99l-9.43 11.16c-1.59 1.79-2.31 3.87-2.1 6.28.2 2.39 1.27 4.37 3.15 5.98l13.87 11.81c1.89 1.49 4.02 2.12 6.4 1.92 2.38-.2 4.4-1.19 5.99-2.98l8.63-10.4c2.67 1.42 5.48 2.62 8.39 3.66s5.87 1.9 8.84 2.61l1.24 14.48c.21 2.45 1.22 4.43 3.06 5.98 1.84 1.56 3.97 2.22 6.42 2.01l18.18-1.56c2.33-.2 4.28-1.2 5.89-3.06 1.58-1.84 2.28-3.97 2.07-6.41l-1.14-13.27c2.98-.97 5.85-2.12 8.59-3.46 2.77-1.36 5.43-2.85 7.99-4.47l11.17 9.43c1.79 1.59 3.89 2.31 6.33 2.1 2.48-.21 4.43-1.27 5.92-3.15l11.82-13.86c1.49-1.9 2.12-4.03 1.91-6.41-.2-2.38-1.18-4.4-2.97-5.99l-10.41-8.63c1.43-2.67 2.62-5.47 3.67-8.39 1.03-2.9 1.89-5.87 2.6-8.83l14.49-1.25c2.44-.2 4.42-1.22 5.98-3.06 1.55-1.84 2.21-3.97 2-6.42l-1.55-18.18c-.2-2.32-1.21-4.28-3.06-5.89-1.85-1.59-3.98-2.27-6.42-2.06l-13.27 1.13c-.96-2.86-2.11-5.7-3.46-8.5a65.99 65.99 0 0 0-4.46-7.91l9.42-11.34c1.59-1.79 2.32-3.86 2.11-6.27-.2-2.39-1.27-4.36-3.15-5.98l-13.85-11.64zm-55.74 37.32c4.89-.42 9.58.11 14.12 1.58 4.52 1.51 8.52 3.72 12.01 6.63 3.46 2.95 6.32 6.52 8.57 10.71 2.22 4.22 3.54 8.76 3.96 13.65.42 4.88-.11 9.59-1.58 14.13-1.51 4.51-3.72 8.51-6.63 12-2.95 3.47-6.51 6.32-10.71 8.57-4.22 2.23-8.76 3.54-13.65 3.96-4.89.42-9.58-.1-14.12-1.58-4.52-1.51-8.52-3.71-12.01-6.63-3.46-2.94-6.32-6.51-8.58-10.7-2.22-4.22-3.54-8.77-3.96-13.66-.41-4.88.12-9.58 1.59-14.12 1.5-4.51 3.72-8.52 6.63-12.01 2.94-3.46 6.51-6.32 10.7-8.57 4.22-2.22 8.77-3.54 13.66-3.96zM158.5 205.69h3.88v-11.93c0-19.94 7.85-34.38 20.52-47.59 12.77-13.31 30.4-21.58 49.82-21.58 19.41 0 37.05 8.26 49.81 21.58 12.67 13.21 20.53 27.64 20.53 47.59v11.93h3.88c6.31 0 11.47 5.17 11.47 11.48v109.75c0 6.32-5.16 11.48-11.47 11.48H158.5c-6.33 0-11.48-5.16-11.48-11.48V217.17c-.01-6.31 5.15-11.48 11.48-11.48zm65.12 69.65-11.95 31.3h42.08l-11.06-31.74c7.02-3.6 11.83-10.93 11.83-19.38 0-12.04-9.77-21.79-21.81-21.79s-21.8 9.75-21.8 21.79c0 8.79 5.21 16.36 12.71 19.82zm-39.52-69.65h97.23v-11.93c0-14.18-5.53-23.29-14.42-32.57-8.8-9.17-20.9-14.87-34.2-14.87-13.29 0-25.4 5.7-34.19 14.87-8.9 9.28-14.42 18.39-14.42 32.57v11.93z"
    }
  })

import VueLuxon from "vue-luxon";
Vue.use(VueLuxon, {
    input: {
        zone: "utc",
        format: "iso",
    },
    output: "short",
});

Vue.config.productionTip = false;
// localStorage.setItem('jwt',"pppppppppp");
// let test = API.test("prova")
// console.log("test", test)

const jwt = require("jsonwebtoken");

const store = new Vuex.Store({
    state: {
        logged: false,
        prelogged: false,
        login: false,
        email: false,
        userId: 0,
        master: false,
        amministrativo: false,
        client_code: false,
        client: false,
        name: false,
        surname: false,
        currMachine: false,
        privacyOK: false,
    },
    mutations: {
        privacyOK(state) {
            state.privacyOK = true;
        },
        prelogged(state, data) {
            state.prelogged = data;
        },
        machine(state, data) {
            state.currMachine = data;
            localStorage.setItem("machine", JSON.stringify(data));
        },
        logout(state) {
            state.email = null;
            state.logged = false;
            state.prelogged = false;
            state.master = false;
            state.login = null;
            state.userId = null;
            state.client_code = null;
            state.client = null;
            state.name = null;
            state.surname = null;
            state.amministrativo = false;
            localStorage.removeItem("jwt");
        },
        login(state, data) {
            // console.log("qua login", data);
            if (data) {
                localStorage.setItem("jwt", data.token);
                let jdata = jwt.decode(data.token);
                console.log({jdata})
                state.email = jdata.email;
                state.login = jdata.login;
                state.userId = jdata.id;
                state.client_code = jdata.client_code;
                state.name = jdata.name;
                state.surname = jdata.surname;
                state.master = jdata.master;
                state.amministrativo = jdata.amministrativo;
                state.client = jdata.client;
                state.logged = data.auth;
                state.currMachine = false;
                // console.log("loggo...", jdata);
            } else {
                localStorage.removeItem("jwt");
                state.email = null;
                state.logged = false;
                state.prelogged = false;
                state.master = false;
                state.login = null;
                state.userId = null;
                state.client_code = null;
                state.client = null;
                state.name = null;
                state.surname = null;
                state.amministrativo = false;
            }
        },
    },
    getters: {
        privacyOK: (state) => {
            return state.privacyOK;
        },
        machine: (state) => {
            return state.currMachine;
        },
        email: (state) => {
            return state.email;
        },
        login: (state) => {
            return state.login;
        },
        logged: (state) => {
            return state.logged;
        },
        prelogged: (state) => {
            return state.prelogged;
        },
        userId: (state) => {
            return state.userId;
        },
        mask: (state) => {
            return state.login && (state.login.startsWith("test") || state.login.startsWith("demo"))
        },
        client: (state) => {
            if(state.login && (state.login.startsWith("test") || state.login.startsWith("demo")))
                return "*******";
            else
                return state.client;
        },
        client_code: (state) => {
            return state.client_code;
        },
        name: (state) => {
            return state.name;
        },
        surname: (state) => {
            return state.surname;
        },
        master: (state) => {
            return state.master;
        },
        amministrativo: (state) => {
            return state.amministrativo;
        },
        marsilli: (state) => {
            return !state.client_code;
        },
    },
});

let token = localStorage.getItem("jwt");
console.log("token", token);
if (token) {
    try {
        // qui non ho la chiave "secret" e non voglio averla. Mi interessa solo sapere se il token
        // è scaduto in modo tale da non provare ad utilizzarlo per niente (tanto poi le API lo rifiuterebbero)
        const { exp } = jwt.decode(token);
        const now = (new Date().getTime() + 1) / 1000
        console.log("payload:",exp - now)
        if (exp < now) {
            console.log("token scaduto")
            localStorage.removeItem("jwt");
        } else {
            let auth = true
            store.commit("login", { token, auth });
        }
    } catch (error) {
        console.log("Token not valid");
        localStorage.removeItem("jwt");
    }
}
let machine = localStorage.getItem("machine");
// console.log("machine", machine);
if (machine) {
    try {
        store.commit("machine", JSON.parse(machine));
    } catch (error) {
        console.error("ERROR",error)
    }
}

(async () => {
    let res = await API.getPrivacy();
    console.log("privacy", res);
    if (res) {
        console.log("setto privacyOK")
        store.commit("privacyOK",null);
    }
})()

/*
import OpenReplay from '@openreplay/tracker';
window.tracker = new OpenReplay({
    projectKey: "ImueCnqlhQI7I0cahWFN",
    ingestPoint: 'https://openreplay.ropel.it/ingest',
    __DISABLE_SECURE_MODE: true,
});
window.tracker.start();
if(store.getters.logged)
    window.tracker.setUserID(store.getters.login)
*/

new Vue({
    router,
    store,
    render: (h) => h(App),
}).$mount("#app");
